import { createFileRoute, redirect } from '@tanstack/react-router';

// EncorePro Backfill merged into the unified EncorePro Pipeline section.
export const Route = createFileRoute('/backend/backfill')({
  // Route-data exemption: a redirect stub. It renders nothing and reads nothing.
  beforeLoad: () => {
    throw redirect({ to: '/backend/pipeline' });
  },
});
